import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import { Lock01Icon } from '@untitled-theme/icons-react'
import { useState } from 'react'

import { sessionStorage } from '@/shared/utils/sessionStorage'

import { useAuth } from '../hooks/useAuth'

export const NotLoggedInScreen = () => {
  const { retriggerAuth } = useAuth()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [uuid, setUuid] = useState('')
  const [token, setToken] = useState('')

  const handleIconClick = () => {
    setDialogOpen(true)
  }

  const handleClose = () => {
    setDialogOpen(false)
    setUuid('')
    setToken('')
  }

  const handleSubmit = async () => {
    if (uuid && token) {
      // Store credentials in sessionStorage for developer use
      sessionStorage.setUid(uuid)
      sessionStorage.setToken(token)
      handleClose()
      // Retrigger authentication with stored credentials
      await retriggerAuth()
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme => theme.palette.grey[100],
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: theme => theme.palette.error.light,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <Lock01Icon
              onClick={handleIconClick}
              style={{ fontSize: 40, color: 'white', cursor: 'default' }}
            />
          </Box>

          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            Zugriff erforderlich
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Dieses Portal kann nicht direkt aufgerufen werden. Bitte kehren Sie zu dem Portal
            zurück, das Sie verwendet haben, und starten Sie den Vorgang erneut.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Administrator.
          </Typography>
        </Paper>
      </Container>

      <Dialog open={dialogOpen} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Developer Access</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="UUID"
            type="text"
            fullWidth
            variant="outlined"
            value={uuid}
            onChange={e => setUuid(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Token"
            type="text"
            fullWidth
            variant="outlined"
            value={token}
            onChange={e => setToken(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" disabled={!uuid || !token}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
